import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const tenantContentEntity: Entity = {
  model: model,
  repository: repository,
}

export default tenantContentEntity
